import styled from 'styled-components';
export const Container = styled.div.withConfig({
  displayName: "BottomMenustyle__Container",
  componentId: "sc-1xnxpbi-0"
})(["", " max-width:", ";a{", "}@media (max-width:", "){", "}@media (max-width:", "){", "}@media (max-width:", "){", "}"], {
  "marginBottom": "120px",
  "marginTop": "5rem",
  "display": "grid",
  "gridTemplateColumns": "repeat(3, minmax(0, 1fr))",
  "gap": "30px"
}, ({
  theme
}) => `${theme.layout.width}`, {
  "cursor": "pointer"
}, ({
  theme
}) => theme.breakpoint.xl, {
  "gap": "1.5rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "gap": "1rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "5rem",
  "gridTemplateColumns": "repeat(1, minmax(0, 1fr))"
});
export const Box = styled.div.withConfig({
  displayName: "BottomMenustyle__Box",
  componentId: "sc-1xnxpbi-1"
})(["", " background-image:url(", ");@media (max-width:", "){", "}"], {
  "position": "relative",
  "display": "flex",
  "minHeight": "300px",
  "width": "100%",
  "alignItems": "center",
  "justifyContent": "center",
  "overflow": "hidden",
  "borderRadius": "1rem",
  "backgroundSize": "cover",
  "backgroundPosition": "center",
  "backgroundRepeat": "no-repeat"
}, ({
  $bgImage
}) => $bgImage, ({
  theme
}) => theme.breakpoint.md, {
  "minHeight": "164px"
});
export const Inside = styled.div.withConfig({
  displayName: "BottomMenustyle__Inside",
  componentId: "sc-1xnxpbi-2"
})(["", " @media (max-width:", "){", "}@media (max-width:", "){", "}"], {
  "zIndex": "10",
  "display": "flex",
  "flexDirection": "column",
  "alignItems": "center",
  "justifyContent": "center",
  "gap": "9px",
  "padding": "2rem"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "padding": "1.5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "gap": "1rem"
});
export const Title = styled.div.withConfig({
  displayName: "BottomMenustyle__Title",
  componentId: "sc-1xnxpbi-3"
})(["", " @media (max-width:", "){", "}@media (max-width:", "){", "}@media (max-width:", "){", "}"], {
  "fontSize": "45px",
  "fontWeight": "700",
  "lineHeight": "50px",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.xl, {
  "fontSize": "40px"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "fontSize": "1.875rem",
  "lineHeight": "2.25rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem"
});
export const Detail = styled.div.withConfig({
  displayName: "BottomMenustyle__Detail",
  componentId: "sc-1xnxpbi-4"
})(["", " @media (max-width:", "){", "}@media (max-width:", "){", "}@media (max-width:", "){", "}"], {
  "textAlign": "center",
  "fontSize": "1.875rem",
  "lineHeight": "34px",
  "fontWeight": "200",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity, 1))"
}, ({
  theme
}) => theme.breakpoint.xl, {
  "fontSize": "28px"
}, ({
  theme
}) => theme.breakpoint.lg, {
  "fontSize": "1.5rem",
  "lineHeight": "2rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "fontSize": "28px"
});
export const BgTrans = styled.div.withConfig({
  displayName: "BottomMenustyle__BgTrans",
  componentId: "sc-1xnxpbi-5"
})(["", " background-image:linear-gradient( rgba(31,31,31,0.55),rgba(31,31,31,0.4));"], {
  "position": "absolute",
  "left": "0px",
  "right": "0px",
  "top": "0px",
  "zIndex": "0",
  "height": "100%"
});